/** Centralized constants for shared top filter UI behavior and sizing. */
export const FILTER_UI_STANDARD = {
  controlFontSize: '0.875rem',
  itemFontSize: '0.875rem',
  headerActionGap: 1,
  menuMaxHeight: 300,
  menuMaxWidth: 350,
  buttonFontSize: '0.75rem',
  rowGapDense: 1,
  rowGapNormal: 1.5,
  /** Gap between fields inside {@link UnifiedTopFilterPanel} (must not use width:100% — breaks strip + actions row). */
  unifiedFieldsGapDense: 1,
  unifiedFieldsGap: 1.5,
  /** {@link FilterStripLayout}: horizontal gap between filter fields (+0.25 vs unified for label breathing room). */
  filterStripFieldsGapDense: 1.25,
  filterStripFieldsGap: 1.75,
  /** Gap between filter scroll strip and Clear/Refresh in {@link CommonFilterPanel}. */
  filterStripToActionsGapDense: 0.75,
  filterStripToActionsGap: 1,
  /** {@link FilterStripLayout}: gap between fields row and action buttons (+0.25 vs base). */
  filterStripToActionsGapStripDense: 1,
  filterStripToActionsGapStrip: 1.25,
  /** {@link FilterStripLayout}: padding on Paper (theme units; +0.25 vs prior compact strip). */
  filterStripPaperPaddingYDense: 1,
  filterStripPaperPaddingY: 1.25,
  filterStripPaperPaddingXDense: 1,
  filterStripPaperPaddingX: 1.25,
  /** {@link FilterStripLayout}: inner row padding so outlined labels stay visible. */
  filterStripInnerPaddingY: 0.25,
  /** Gap between Clear and Refresh buttons. */
  filterActionButtonsGapDense: 0.5,
  filterActionButtonsGap: 1,
  /** Room above filter row (below panel title / alerts). */
  filterControlsPaddingTop: 2,
  filterControlsPaddingTopDense: 1.5,
  /** Top padding inside horizontal scroll strip (room for outlined labels). */
  filterScrollAreaPaddingTopDense: 1.5,
  filterScrollAreaPaddingTop: 2,
} as const;
